'use client';

import { InternalNetworkSensorConnectionSteps } from '@terra/ui-design-system';
import { useInternalNetworkSensorConnectionReadiness } from './useInternalNetworkSensorConnectionReadiness';

type InternalNetworkSensorConnectionProgressProps = {
  networkId: string;
};

export function InternalNetworkSensorConnectionProgress({
  networkId,
}: InternalNetworkSensorConnectionProgressProps) {
  const readiness = useInternalNetworkSensorConnectionReadiness({
    networkId,
    pollWhileWaiting: true,
  });

  return (
    <InternalNetworkSensorConnectionSteps
      isLoading={readiness.isLoading}
      hasEnrollment={readiness.hasEnrollment}
      sensorOnline={readiness.sensorOnline}
      callbackBound={readiness.callbackBound}
      canVerify={readiness.canVerify}
    />
  );
}
